/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Everything runs in your browser — your text is never uploaded.`)
};

const es_rd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Todo se ejecuta en tu navegador — tu texto nunca se carga.`)
};

const de_rd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Alles läuft in Ihrem Browser — Ihr Text wird niemals hochgeladen.`)
};

const nl_rd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Alles draait in uw browser — uw tekst wordt nooit geüpload.`)
};

const fr_rd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Tout s'exécute dans votre navigateur — votre texte n'est jamais téléchargé.`)
};

const it_rd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Tutto viene eseguito nel tuo browser — il tuo testo non viene mai caricato.`)
};

const pt_br2_rd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Tudo é executado no seu navegador — seu texto nunca é enviado.`)
};

const pt_rd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Tudo é executado no seu navegador — o seu texto nunca é carregado.`)
};

const ja_rd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。すべてがブラウザで実行されます。テキストはアップロードされません。`)
};

const zh_rd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。所有操作都在你的浏览器中运行——你的文本永远不会被上传。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_faq3_a", locale)
	if (locale === "en") return en_rd_faq3_a(inputs)
	if (locale === "es") return es_rd_faq3_a(inputs)
	if (locale === "de") return de_rd_faq3_a(inputs)
	if (locale === "nl") return nl_rd_faq3_a(inputs)
	if (locale === "fr") return fr_rd_faq3_a(inputs)
	if (locale === "it") return it_rd_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_rd_faq3_a(inputs)
	if (locale === "pt") return pt_rd_faq3_a(inputs)
	if (locale === "ja") return ja_rd_faq3_a(inputs)
	return zh_rd_faq3_a(inputs)
};